// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const ApiVersionScheme = {
    header: (value) => {
        return Object.assign(Object.assign({}, value), { type: "header", _visit: function (visitor) {
                return FernIr.ApiVersionScheme._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "header":
                return visitor.header(value);
            default:
                return visitor._other(value);
        }
    },
};
